import { HotelListHeaderTitlePropertiesType } from "@website/accommodation-ui/hotel-list-header/hotel-list-header.types";
import { Skeleton } from "@website/ui/skeleton";
import { deepCompare } from "@website/utils/deep-compare";
import { numberConvert } from "@website/utils/number-convert";
import { useRouter } from "next/router";
import { FC, memo } from "react";

const Component: FC<HotelListHeaderTitlePropertiesType> = ({
  city,
  totalItem,
  hasCityPrefix = true,
  loading
}: any) => {
  const router = useRouter();

  return (
    <h2
      className="text-on-surface-high-emphasis w-full pt-5 font-medium lg:pt-0"
      data-testid="header_title"
    >
      {process.env.NEXT_PUBLIC_APP_NAME === "tour" ? (
        loading ? (
          `در جستجوی تور‌های ${city} ...`
        ) : (
          `${numberConvert(totalItem, {
            locale: "fa"
          })} تور ${city}`
        )
      ) : city ? (
        hasCityPrefix ? (
          `${numberConvert(totalItem, {
            locale: router.locale
          })} اقامتگاه در ${city}`
        ) : (
          `${numberConvert(totalItem, { locale: router.locale })} اقامتگاه`
        )
      ) : (
        <div className="h-6">
          <Skeleton shape="rectangle" />
        </div>
      )}
    </h2>
  );
};

export const HotelCityTitle = memo(Component, deepCompare);
